import React from 'react';
import { setBreadcrumbs } from 'works/legacy/lib/client-store';
import { Colors } from '@common/tokens';
import { CandidatesTable } from './candidates-table';
import { AppContent } from '@common/components';

export function SupplierCandidatesPage() {
  setBreadcrumbs([{ name: 'Candidates', path: '/works/supplier/candidates' }]);

  return (
    <AppContent>
      <CandidatesTable />
      <style jsx>{`
        section :global(.candidate) {
          border-top: 1px solid ${Colors.steel};
          border-collapse: collapse;
        }
      `}</style>
    </AppContent>
  );
}
